//@flow
import type Model from '../Model/model';
import BaseCollection from './baseCollection';

export default class Collection<ModelObject: Object, T:Model<ModelObject>> extends BaseCollection<ModelObject, T, $Shape<ModelObject>[]> {

  __parse(modelsAttrs:?ModelObject[]):ModelObject[] {
    return modelsAttrs || [];
  }
}
